export const hasOne = <ArrayType>(arr: ArrayType[] | undefined): arr is [ArrayType] => arr?.length === 1
